import NotificationsIcon from '@mui/icons-material/Notifications';
import { IconButton } from '@mui/material';
import { isImpersonating } from '@pn/core/utils/impersonate';
import {
  beamerButtonId,
  type BeamerConfigId,
  useAutoInitializeBeamer,
} from '@pn/services/support/useAutoInitializeBeamer';

type Props = {
  configId: BeamerConfigId;
};

export const BeamerButton = ({ configId }: Props) => {
  useAutoInitializeBeamer(configId);

  return (
    <IconButton id={beamerButtonId} size="small" disabled={isImpersonating()}>
      <NotificationsIcon />
    </IconButton>
  );
};
